module.exports = __webpack_public_path__ + "o.no1.d55d93f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/o.no1.jpg
// module id = tuap
// module chunks = 0